import { call, put, takeEvery } from 'redux-saga/effects';

import AxiosFactory from 'utils/axiosFactory';
import { Config, ENVIRONMENT } from 'utils/webappConfig';
import { getLogger } from 'utils/logger';

import * as actions from './actions';
import { transformResponseToInstitutions, transformResponseToInstitution, transformSearchResponseToInstitutions } from './transformers';
import {mkQcsSyncResourcesPayload} from '../qcsSyncResourceTypes';

const qcsAxios = AxiosFactory.get('qcs');
const log = getLogger('data/institutions/sagas');

// =================================================================================================
// getInstitution
// =================================================================================================
export function* getInstitution(action: any): Generator<*, *, *> {
  // log.debug('getInstitution called...');

  const { institutionId, idType } = action.payload;
  let requestUrl = `${Config.environments[ENVIRONMENT].services_url}/institutions/${institutionId}`;
  if (idType) {
    requestUrl += `?idType=${idType}`;
  }

  try {
    const response = yield call(qcsAxios.get, requestUrl);
    // log.debug('Retrieved institution, response=', response);

    const institution = transformResponseToInstitution(response);
    // log.debug('getInstitution response after transform=', institution);

    yield put(actions.getInstitutionResponse(institution));
  } catch (error) {
    log.log('Error retrieving institution', error);
    yield put(actions.getInstitutionResponse(error));
  }
}

// =================================================================================================
// getPopularInstitutions
// =================================================================================================
export function* getPopularInstitutions(): Generator<*, *, *> {
  log.log('getPopularInstitutions called...');

  const requestUrl = `${Config.environments[ENVIRONMENT].services_url}/institutions/suggested?limit=12`;

  try {
    const response = yield call(qcsAxios.get, requestUrl);
    log.log('Retrieved popular institutions, response=', response);

    const institutions = transformResponseToInstitutions(response.data);
    log.log('getPopularInstitutions response after transform=', institutions);

    yield put(actions.getPopularInstitutionsSuccess(mkQcsSyncResourcesPayload({ resources: institutions })));
  } catch (error) {
    log.log('Error retrieving popular institutions', error);
    yield put(actions.getPopularInstitutionsFailure(error));
  }
}

// =================================================================================================
// searchForInstitutions
// =================================================================================================

export function* searchForInstitutions({ payload : searchString, meta }: {payload: any, meta: any}): Generator<*, *, *> {
  log.log('searchForInstitutions called...', searchString, Config);
  const { resolve, reject } = meta;

  const requestUrl = `${Config.environments[ENVIRONMENT].services_url}/institutions/search?name=${searchString}`;

  log.log('searchForInstitutions requestUrl...', requestUrl);
  try {
    const response = yield call(qcsAxios.get, requestUrl);
    log.log('searchForInstitutions response...', response);

    const institutions = transformSearchResponseToInstitutions(response);
    log.info('searchForInstitutions response after transform=', institutions);

    yield put(actions.searchForInstitutionsSuccess(institutions));
    yield call(resolve, institutions);
  } catch (error) {
    // TODO: explicitly check for error type
    log.error('error');
    yield put(actions.searchForInstitutionsFailure(error));
    yield call(reject, error);
  }
}

// =============================================================================
// Watchers
// =============================================================================

function* getInstitutionActionWatcher() : Generator<*, *, *> {
  yield takeEvery(actions.getInstitution, getInstitution);
}

function* getPopularInstitutionsActionWatcher() : Generator<*, *, *> {
  yield takeEvery(actions.getPopularInstitutions, getPopularInstitutions);
}

function* searchForInstitutionsActionWatcher() : Generator<*, *, *> {
  yield takeEvery(actions.searchForInstitutions, searchForInstitutions);
}

// =============================================================================
// Exports
// =============================================================================

export default [
  getInstitutionActionWatcher,
  getPopularInstitutionsActionWatcher,
  searchForInstitutionsActionWatcher,
];

